import { ArrowUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WORLDS } from '../data/studio';

export default function Footer({ onNavigate }) {
  return (
    <footer className="relative border-t border-cyan-500/10 overflow-hidden" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse-dot" />
              <span className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500">System coordinates</span>
            </div>
            <p className="font-mono-precision text-xs text-slate-500 leading-loose">
              LAT 0.000 · LON ∞<br />
              NODE 01 — ACTIVE<br />
              sidetrackaistudio.com
            </p>
          </div>
          <div>
            <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-5">The six worlds</p>
            <ul className="space-y-2.5">
              {WORLDS.map((w) => (
                <li key={w.id}>
                  <button
                    onClick={() => onNavigate('worlds')}
                    className="text-sm text-slate-400 hover:text-cyan-300 transition-colors duration-300"
                    data-testid={`footer-link-${w.id}`}
                  >
                    {w.title}
                  </button>
                </li>
              ))}
              <li>
                <Link to="/u99" className="text-sm text-amber-300/80 hover:text-amber-200 transition-colors duration-300" data-testid="footer-link-united99">United 99 Unleashed</Link>
              </li>
            </ul>
          </div>
          <div className="flex md:justify-end items-start">
            <button
              onClick={() => onNavigate('top')}
              className="group flex items-center gap-3 font-mono-precision text-[11px] uppercase tracking-[0.25em] text-slate-400 hover:text-cyan-300 transition-colors duration-300"
              data-testid="footer-back-to-top-btn"
            >
              Return to surface
              <span className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center group-hover:border-cyan-400/60 group-hover:-translate-y-1 transition-all duration-300">
                <ArrowUp size={15} />
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="relative select-none pointer-events-none px-6" aria-hidden="true">
        <p className="font-celestial text-center text-[13vw] leading-[0.85] tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-slate-800/80 to-[#02040a] whitespace-nowrap">
          SIDETRACK
        </p>
        <div className="h-10" />
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-precision text-[10px] tracking-[0.2em] text-slate-600">
            © 2026 SIDETRACK AI STUDIOS · ALL SIGNALS RESERVED
          </p>
          <p className="font-mono-precision text-[10px] tracking-[0.2em] text-slate-600">
            STORIES · IDEAS · TECHNOLOGY · MUSIC · <Link to="/admin" className="hover:text-slate-400" data-testid="footer-admin-link">VAULT</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
